import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c08e22be"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-id"]
const _hoisted_2 = ["aria-expanded", "aria-label"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = {
  key: 1,
  class: "ss-panel-preview",
  "data-id": "ss-panel-preview"
}
const _hoisted_5 = {
  key: 2,
  class: "ss-toolbar-spinner",
  "data-id": "ss-hydrate-spinner"
}
const _hoisted_6 = {
  key: 0,
  class: "ss-root"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectionSetTreeNode = _resolveComponent("SelectionSetTreeNode")!

  return (_openBlock(), _createElementBlock("div", {
    class: "ss-tree",
    "data-id": 'ss-tree-' + _ctx.field
  }, [
    _createElementVNode("div", {
      class: "ss-panel-header",
      "data-id": "ss-panel-toggle",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.togglePanel && _ctx.togglePanel(...args)))
    }, [
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["ss-panel-chevron", { opened: _ctx.panelOpen }]),
        "aria-expanded": _ctx.panelOpen ? 'true' : 'false',
        "aria-label": 
          _ctx.panelOpen ? 'Collapse selection fields' : 'Expand selection fields'
        ,
        "data-id": "ss-panel-chevron"
      }, null, 10, _hoisted_2),
      (_ctx.panelOpen)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "ss-reset",
            disabled: _ctx.disabled || _ctx.hydrating,
            "data-id": "ss-reset",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.resetToDefault && _ctx.resetToDefault(...args)), ["stop"]))
          }, " Reset to default ", 8, _hoisted_3))
        : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.collapsedSummary), 1)),
      (_ctx.hydrating)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5))
        : _createCommentVNode("", true)
    ]),
    (_ctx.panelOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_SelectionSetTreeNode, {
            segments: [],
            meta: _ctx.rootMeta,
            depth: 0,
            "ancestor-types": [],
            disabled: _ctx.disabled
          }, null, 8, ["meta", "disabled"])
        ]))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}